<!-- Toast centralizzato per tutte le pagine che usano questo layout -->
<p-toast position="top-center" key="tc" />

<!-- Spostato qui con appendTo="body" per evitare problemi di z-index -->
<p-confirmdialog appendTo="body" />

<!-- Contenitore flessibile che occupa sempre il 100% dell'altezza disponibile -->
<div class="bg-surface-100 flex h-full min-h-0 w-full flex-col dark:bg-surface-900">
  <ng-content></ng-content>
</div>
